type Props = {
  plateNumber?: string;
};

export const LicensePlate = ({ plateNumber }: Props) => {
  return (
    <div className="border border-gray-600 inline-flex rounded items-stretch bg-white dark:bg-gray-700">
      <div className="bg-blue-600 w-2" />
      <p className="px-2 py-1 font-bold text-black dark:text-white">{plateNumber ?? '--'}</p>
      <div className="bg-blue-600 w-2" />
    </div>
  );
};
